import React from 'react';
import Card from '@/components/ui/Card';
import OperationStatus from '@/components/ui/OperationStatus';

const LoadingOverlay: React.FC = () => {
  return (
    <Card className="relative">
      <div className="absolute inset-0 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm rounded-lg z-10 flex items-center justify-center">
        <div className="w-full max-w-lg p-8">
          <OperationStatus
            state="pending"
            label="AI analysis in progress"
            description="Our AI is analyzing your team data."
            expectedDuration="This may take 30-60 seconds."
          />
        </div>
      </div>
      <div className="opacity-30">
        <div className="border-b border-gray-200 dark:border-gray-700 pb-4">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Analysis Results</h2>
        </div>
        <div className="h-32 bg-gray-100 dark:bg-gray-800 rounded mt-4"></div>
      </div>
    </Card>
  );
};

export default LoadingOverlay;
